import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const money = (n, c = "PHP") =>
  new Intl.NumberFormat("en-PH", { style: "currency", currency: c || "PHP" }).format(Number(n) || 0);

const TZ = "Asia/Manila";
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-PH", { timeZone: TZ, year: "numeric", month: "short", day: "numeric" }) : "—");
export const fmtDateTime = (s) =>
  s ? new Date(s).toLocaleString("en-PH", { timeZone: TZ, month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—";
export const fmtTime = (s) => new Date(s).toLocaleTimeString("en-PH", { timeZone: TZ, hour: "numeric", minute: "2-digit" });

export const idemKey = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const validityLabel = (v, u) => `${v} ${u === "DAYS" ? "day" : "month"}${v === 1 ? "" : "s"}`;

export const ROLE_HOME = { customer: "/app", admin: "/admin", super_admin: "/admin", cashier: "/login", provider: "/provider", sales_manager: "/sales", sales_agent: "/sales" };
